import { Empty } from 'antd';
import { EmptyProps } from 'antd/lib';
import NoDataDesert from 'images/NoDataDesert.svg';
import React from 'react';

const noDataImages = {
	default: Empty.PRESENTED_IMAGE_DEFAULT,
	desert: NoDataDesert,
	simple: Empty.PRESENTED_IMAGE_SIMPLE
};

export type NoDataProps = EmptyProps & {
	imageName?: keyof typeof noDataImages;
};

export const NoData: React.FC<NoDataProps> = ({ image, imageName = 'desert', ...rest }) =>
	<Empty
		image={ image ?? noDataImages[ imageName ] }
		{ ...rest } />;
